import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {Router, RouterModule, RouterOutlet} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {LoadingService} from '@shared/loading-interceptor/loading.service';
import {TunnelService} from '@shared/tunnel-interceptor/tunnel.service';
import {delay, takeUntil} from 'rxjs/operators';
import {ReplaySubject} from 'rxjs';
import {LoaderComponent} from '@shared/loader/loader.component';
import {AlertComponent} from '@app/shared';
import {CommonModule} from '@angular/common';
import {ConfigProvider} from '@app/blocks/config/config.provider';
import {FooterComponent} from '@app/layouts/footer/footer.component';
import {NavbarComponent} from '@app/layouts/navbar/navbar.component';
import {PopInSharedService} from "@shared/pop-in/pop-in-shared.service";

@Component({
    selector: 'app-root',
    templateUrl: './main.component.html',
    standalone: true,
    imports: [
        RouterModule,
        CommonModule,
        RouterOutlet,
        LoaderComponent,
        TranslateModule,
        AlertComponent,
        FooterComponent,
        NavbarComponent,
    ],
})
export class NedMainComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('popinHost', { read: ViewContainerRef}) popinHost!: ViewContainerRef;

    isLoading$;
    isTunnel: boolean = false;
    private _hasFooter = false;
    version: string;
    mois: string;
    annee: string;
    private destroyed$ = new ReplaySubject(1);
    isFaqPage = false;

    constructor(
        private loadingService: LoadingService,
        private tunnelService: TunnelService,
        private configProvider: ConfigProvider,
        private router: Router,
        private popInSharedService: PopInSharedService
    ) {
        this.isLoading$ = this.loadingService.getLoading()
            .pipe(delay(0));
        this.tunnelService.getTunnel().pipe(takeUntil(this.destroyed$))
            .subscribe(response => this.isTunnel = response);
        this.tunnelService.getHasFooterForced().pipe(takeUntil(this.destroyed$))
            .subscribe(response => this._hasFooter = response);
        this.version = this.configProvider.config.version || '';
        this.mois = this.configProvider.config.moisInstallation || '';
        this.annee = this.configProvider.config.anneeInstallation || '';
    }

    ngAfterViewInit() {
        this.popInSharedService.registerHost(this.popinHost);
    }

    ngOnDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }

    scrollTo($event: Event, id: string) {
        $event.preventDefault();
        const div = document.getElementById(id);

        if (!div) {
            return;
        }

        let focusable: HTMLElement | null = div.querySelector('h1');
        switch (id) {
            case 'footer':
                focusable = div.querySelector('.logoFooter');
                break;
            case 'faq-menu':
                focusable = div.querySelector('button');
                break;
        }

        if (focusable) {
            if (!focusable.hasAttribute('tabindex')) {
                focusable.setAttribute('tabindex', '0');
            }
            (focusable as HTMLElement).focus();
            focusable.removeAttribute('tabindex');
        }
        window.scrollTo(0, div.getBoundingClientRect().top + window.scrollY);
    }

    keydownSkiplinks(event: KeyboardEvent) {
        if (event.key === "Enter") {
            event.preventDefault();
            if (!event.target) return;
            (event.target as HTMLElement).click();
        }
    }

    ngOnInit(): void {
        this.checkCurrentRoute();

        this.router.events.subscribe(() => {
            this.checkCurrentRoute();
        });
    }

    checkCurrentRoute(): void {
        this.isFaqPage = this.router.url === '/communication/faq';
    }

}
